export const toFormData = (contactId, files, note, leadId, dateEntered) => {
  const formData = new FormData()
  formData.append('leadId', leadId)
  formData.append('note', note)
  formData.append('dateEntered', dateEntered)
  files.forEach(file => {
    if (!file.id) {
      formData.append('newAttachments', file)
    } else {
      formData.append('attachmentIds', file.id)
    }
  })

  return formData
}
